import { BytesLike } from 'ethers';
import { Web3Provider } from '@ethersproject/providers';

const signTypedData = async (
    library: any,
    account: string,
    message: string
): Promise<BytesLike> => {
    let web3Provider, isMetamask, signature;

    if (library instanceof Web3Provider) {
        web3Provider = library;
        isMetamask = web3Provider.provider.isMetaMask;

        if (isMetamask) {
            web3Provider.provider.isMetaMask = false;
        }
    }

    if (isMetamask) {
        try {
            signature = await library.send('eth_signTypedData_v4', [account, message]);
        } catch (error) {
            throw error;
        } finally {
            (web3Provider as Web3Provider).provider.isMetaMask = true;
        }
    } else {
        signature = await library.jsonRpcFetchFunc('eth_signTypedData_v4', [
            account,
            message,
        ]);
    }

    return signature;
};

export default signTypedData;
